import { Heading, HeadingVariants, Input, Text } from '@/ui'
import { getCurrentUser } from '@/selectors/user.selectors'
import { useReselector } from '@/utils/sharedHooks'
import { VerificationDialog } from '../../../account-details-card/credentials/VerificationDialog'
import { ChangeEmailDialog } from './ChangeEmailDialog'
import { ChangePassword } from './ChangePassword'

export const Credentials = () => {
  const currentUser = useReselector(getCurrentUser)
  const isVerified = Boolean(currentUser?.verifiedAt)

  return (
    <div className="flex flex-col gap-4">
      {currentUser && (
        <div className="flex flex-col gap-2">
          <Heading variant={HeadingVariants.H3}>Email</Heading>

          <div className="flex flex-col md:flex-row md:items-stretch gap-2">
            <Input
              className="flex-1 md:flex-none md:w-[350px]"
              placeholder={currentUser.email}
              value={currentUser.email}
              error={!currentUser.verifiedAt}
              readOnly
            />
            <div className="w-full md:w-auto">
              <ChangeEmailDialog />
            </div>
          </div>

          <div className="flex gap-2 items-center">
            {!isVerified && (
              <Text className="text-danger">
                This email has not been verified
              </Text>
            )}
            <VerificationDialog isVerified={isVerified} />
          </div>
        </div>
      )}

      <div className="flex flex-col gap-2">
        <Heading variant={HeadingVariants.H3}>Password</Heading>

        <div className="flex flex-col md:flex-row md:items-stretch gap-2">
          <Input
            className="flex-1 md:flex-none md:w-[350px]"
            value="********"
            readOnly
          />
          <div className="w-full md:w-auto">
            <ChangePassword />
          </div>
        </div>
      </div>
    </div>
  )
}
